"use client";
import Image from "next/image";
import React, { FC } from "react";

interface StatCardProps {
  value: string;
  label: string;
  icon?: any;
  icon2?: any;
  color?: string;
  colorText?: string;
  i: number;
}

const StatCard: FC<StatCardProps> = ({
  value,
  label,
  icon,
  icon2,
  color,
  colorText,
  i,
}) => {
  return (
    <div
      className={`bg-white relative p-6 flex flex-col justify-end group items-start w-full sm:h-[286px] h-[300px] border-b-10 border-${color} bg-no-repeat bg-cover 
    ${i === 0
          ? "xl:bg-none hover:xl:bg-[url('/images/about/n1.png')] bg-[url('/images/about/n1.png')]"
          : i % 2 === 1
            ? "xl:bg-none hover:xl:bg-[url('/images/about/n1.png')] bg-[url('/images/about/n1.png')]"
            : "xl:bg-none hover:xl:bg-[url('/images/about/n2.png')] bg-[url('/images/about/n2.png')]"
        }
  `}
    >
      {" "}
      <div className="flex justify-between w-full">
        <h2 className="text-heading-1 text-primary-text font-normal">
          {value}
        </h2>
        <span
          className={
            " xl:h-[72p] xl:w-[72px] h-[64px] w-[64px] absolute top-[24px] right-[24px] flex items-center  justify-center "
          }
        >
          <Image
            height={48}
            width={48}
            className="h-[48px] w-[48px] xl:block hidden group-hover:xl:hidden"
            src={icon}
            alt=""
          />

          <Image
            height={48}
            width={48}
            className="h-[48px] w-[48px] xl:hidden block group-hover:xl:block"
            src={icon2}
            alt=""
          />
        </span>
      </div>
      <p className={`mt-2 text-base text-heading-6 font-normal ${colorText}`}>
        {label}
      </p>
    </div>
  );
};

export default StatCard;
